import React from 'react';
import { styled } from '@mui/material/styles';
import { ArrowLeftIcon, ArrowRightIcon } from './Icons';
import { Box, IconButton } from '@mui/material';

const SliderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  backgroundColor: 'transparent',
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    overflow: 'hidden' 
  }
}));

const SliderContent = styled(Box)(({ theme }) => ({
  flexWrap: 'nowrap',
  alignContent: 'flex-start',
  transform: 'translateZ(0)',
  display: 'flex',
  padding: '0 0 10px 0',
  overflowY: 'hidden',
  overflowX: 'auto',
  scrollBehavior: 'smooth',
  WebkitOverflowScrolling: 'touch',
  '& > div': {
  	marginLeft: theme.spacing(1),
  	marginRight: theme.spacing(2),
  },
  '&.dontScroll': {
    flexWrap: 'wrap'
  }
}));

const ScrollAction = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: theme.spacing(-5),
  color: theme.palette.text.primary,
  height: '100%',
  padding: '0 5px',
  zIndex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  //background: 'linear-gradient(270deg, rgba(0,0,0,0) 25%, rgba(255,251,245,1) 100%)'
  background: 'rgba(255,251,245,0.86)',
  [theme.breakpoints.down('md')]: {
  	display: 'none'
  }
}));

const Slider = (props) => {

	const {data, dontScroll, children, onScrollEnd} = props; 
	const scrollElement = React.useRef(null); 
	const [showArrow, setShowArrow] = React.useState({
	  right: false,
		left: false
	});

	const handleScroll = (e) => {
	    const scrollLeft = Math.round(e.target.scrollLeft);
	    const scrollMax = e.target.scrollWidth - e.target.offsetWidth;

	    if(scrollLeft === 0) {
	      setShowArrow({
	        left: false,
	        right: true
	      });
	    }
	    if(scrollLeft > 0 && scrollLeft < (scrollMax-10) && (!showArrow.left || !showArrow.right)) {
	      setShowArrow({
	        left: true,
	        right: true
	      });
	    }
	    if(scrollLeft >= (scrollMax-10) && showArrow.right) {
	      setShowArrow({
	        left: true,
	        right: false
	      });
	      if(onScrollEnd) {
	      	onScrollEnd();
	      }
	    }
	}

	const handleWindowScroll = (e) => {
		if(!scrollElement.current) return;
    const element = scrollElement.current.getBoundingClientRect();
    if((Math.round(element.bottom) - window.innerHeight) <= 0) {
    	if(onScrollEnd) {
      	onScrollEnd();
      }
    }
	}

	React.useEffect(() => {
		if(dontScroll) {
			window.removeEventListener('scroll', handleWindowScroll);
	    window.addEventListener('scroll', handleWindowScroll);
	    return () => {
	    	window.removeEventListener('scroll', handleWindowScroll);
	    }
		}
	}, [children]);

	React.useEffect(() => {
    if(!dontScroll && scrollElement.current && scrollElement.current.scrollWidth > scrollElement.current.offsetWidth) {
    	if(scrollElement.current.scrollLeft === 0) {
    		setShowArrow({
	        left: false,
	        right: true
	      });
    	}
    	if(scrollElement.current.scrollLeft > 0) {
    		setShowArrow({
	        left: true,
	        right: true
	      });
    	}
    }
	}, [dontScroll, children, scrollElement.current]);

	return(
		<SliderContainer>
			{
        (showArrow.left && Boolean(scrollElement.current)) &&
				<ScrollAction>
					<IconButton 
						color="inherit"
						onClick={() => scrollElement.current.scrollLeft -= Math.round(scrollElement.current.offsetWidth) }
					>
						<ArrowLeftIcon fontSize="large" color="inherit" />
					</IconButton>
				</ScrollAction>
			}
			{
        (showArrow.right && Boolean(scrollElement.current)) &&
        <ScrollAction 
					sx={{
						left: 'auto',
						right: (theme) => theme.spacing(-5)
					}}
				>
					<IconButton 
						color="inherit"
						onClick={() => scrollElement.current.scrollLeft += Math.round(scrollElement.current.offsetWidth)}
					>
						<ArrowRightIcon fontSize="large" color="inherit" />
					</IconButton>
				</ScrollAction>
      }
      <SliderContent
      	className={dontScroll && 'dontScroll'}
        ref={scrollElement}
        onScroll={handleScroll}
      >
      	{ children }
      </SliderContent>
    </SliderContainer>
	);
}

export default Slider;